import React, { useState, useEffect } from "react";

// Components
import Table from "../../../component/table";
import DashboardPopOver from "../../../component/DashboardPopOver";
import { useDispatch } from "react-redux";
import {
  addToMyDashboard,
  deleteWidgets,
} from "../../../redux/actions/analytics";

function ToDoBacklogTable({
  id,
  title,
  cardCss,
  menu,
  data,
  isDisable,
  setUpdate,
  update,
  tab,
}) {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    // Creating table Data
    if (data) {
      const newTableData = data.todos.map((todoElement) => {
        const obj = {
          "To Do": todoElement.todoName,
        };
        for (const todoBacklogData of Object.keys(data.todoBacklogs)) {
          const filteredData = data.todoBacklogs[todoBacklogData].find(
            (element) => element.todoId === todoElement.todoId
          );
          obj[todoBacklogData] = filteredData ? filteredData.count : 0;
        }
        return obj;
      });

      setTableData(newTableData);
    }
  }, [data]);

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };

    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
    };

    dispatch(deleteWidgets(request));
  };

  return (
    <div className="w-full h-full">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          menus={menu}
          handleOnClick={() =>
            tab ? handleDeleteWidgets() : handleAddToMyDashboard()
          }
          isDisable={isDisable}
        />
      </div>

      <div className="h-full w-full space-y-2">
        <h2 className="text-sm font-semibold text-[#313439] leading-5">
          {title}
        </h2>
        <div className="w-full h-[93%]">
          {tableData?.length > 0 ? (
            <div className="max-h-full max-w-full overflow-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
              <Table
                heads={Object.keys(tableData[0]).map((item) => {
                  const obj = {
                    headName: item,
                    isSort: false,
                    value: item,
                  };
                  return obj;
                })}
                tClass="table-auto w-full border-separate border-spacing-y-2"
                hClass="text-[10px] leading-2 text-[#fff] !bg-[--bg-color-500] tracking-wide sticky top-0 first:text-left text-center"
                bClass="text-[10px] first:text-left text-center"
                thClass={`h-[24px] whitespace-nowrap first:text-left text-center first:font-semibold font-normal first:rounded-l last:rounded-r max-w-10 sticky top-0 pl-2`}
              >
                {tableData.map((tableItem, i) => {
                  return (
                    <tr
                      key={i}
                      className="whitespace-nowrap bg-[#fff] h-6 !rounded"
                    >
                      {Object.keys(tableData[0]).map((tableKeys, index) => {
                        return (
                          <td
                            key={tableKeys + index}
                            title={tableItem[tableKeys]}
                            className={`text-[10px] max-w-full truncate first:text-left text-center ${
                              index === 0 && "font-semibold pl-2"
                            } rounded`}
                          >
                            {tableItem[tableKeys]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </Table>
            </div>
          ) : (
            <div className="h-full flex justify-center items-center text-sm font-semibold leading-5 capitalize">
              No Data Found
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ToDoBacklogTable;
